import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const SeasonalityTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();

    const data = rows.filter(row => row.Category === "SEASONALITY");

    return <EconomicTable data={data} title="Seasonality Analysis" defaultRowData={{ Category: "SEASONALITY", Topic: "Monthly" }} groupBy="Topic" groupOrder={["Monthly", "Quarterly"]} useDataHook={useMarketInternalsData} />;
};

export default SeasonalityTab;
